import { gql } from "@grandvisionhq/graphql";
const GET_PAYMENT_STATUS_BY_TOKEN = gql`
  query GetPaymentStatus($token: String!) {
    getOrderByToken(token: $token) {
      orderNumber
      state {
        key
      }
    }
  }
`;
export {
  GET_PAYMENT_STATUS_BY_TOKEN
};
//# sourceMappingURL=get-payment-status-by-token.js.map
